<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <a
      class="clickable-area rounded-md py-0 px-4 focus-link"
      [routerLink]="[checkoutUrl()]">
      <div class="loyalty-program-image-container mr-4">
        <img
          *ngIf="loyaltyProgramImageUrl()"
          class="loyalty-program-image"
          alt=""
          [src]="loyaltyProgramImageUrl()" />
      </div>
      <h2 class="loyalty-program-name m-0">{{ loyaltyProgram.name }}</h2>

      <rd-shared-icon
        [iconSymbol]="'icon-chevron-right'"
        class="next-step-arrow ml-auto"></rd-shared-icon>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="loading loading-container rounded-md py-0 px-4">
      <div class="loyalty-program-image-container mr-4"></div>
      <div class="loyalty-program-name"></div>
      <div class="next-step-arrow ml-auto"></div>
    </div>
  </ng-container>
</ng-container>
